<div class="cf_search-bar cf_search-bar-border">
	<div class="cf_search-bar-content">
		<img
			class="cf_search-bar-logo"
			src="{{ logoPath || themeSettings.logoImgSrc }}"
			(click)="goHome()"
		/>
		@if(enableSearch) {
		<form (ngSubmit)="performSearch()">
			<div class="cf_search-bar-controls">
				<div class="cf_search-bar_input">
					<input
						type="text"
						id="search"
						name="search"
						[(ngModel)]="currentSearchPredicate"
						autocomplete="off"
						autofocus
						placeholder="{{ placeholderText }}"
						#searchBox
						(keydown)="inputKeyUpWrapper($event)"
						(keypress)="inputKeyUpWrapper($event)"
						(keyup)="inputKeyUpWrapper($event, true)"
					/>
				</div>
				<button class="cf_search-bar-search-button"></button>
				@if(hasSuggestions) {
				<div class="autocomplete-menu" #typeaheadMenu>
					@for( suggestion of suggestions; track suggestion){
					@if(containsSearchTerm(suggestion)) {
					<div (click)="applySuggestion(suggestion)">
						<div
							class="autocomplete-menu-item"
							[ngClass]="{
										active: typeaheadActiveIndex === $index,
									}"
						>
							@for(piece of getSuggestionInPieces(suggestion);
							track $index) {
							<span
								[ngClass]="{
									'autocomplete-menu-item-piece-bold':
										equalsSearchTerm(piece)
								}"
								>{{ piece }}</span
							>
							}
						</div>
					</div>
					} @else {
					<div
						class="autocomplete-menu-item"
						[ngClass]="{
									active: typeaheadActiveIndex === $index,
								}"
						(click)="applySuggestion(suggestion)"
					>
						{{ suggestion }}
					</div>
					} }
				</div>
				}
			</div>
		</form>
		<review-modal
			#reviewComponent
			[reviews]="reviews"
			[showModal]="showReviewModal && !isReviewModalDismissed"
		></review-modal>
		<navigation-panel
			[isFollowEnabled]="isFollowEnabled"
			[unseenEventCount]="unseenEventCountsForAll"
			[updateCount]="updateCount"
			[reviews]="reviews"
			(goHome)="goHome()"
			(goToCompanyUpdate)="goToCompanyUpdate($event)"
			(goToMyUpdates)="goToMyUpdates()"
			(goToPreferences)="goToPreferences()"
			(showPendingUpdates)="showPendingUpdates()"
		>
		</navigation-panel>
		}
	</div>
</div>
